<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn icon dark title="Back to linked account list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="company" pageId="linked-account-manage" color="white"></help-link>
                    <v-btn v-if="hasEditRights && isLinkedAccountAdminUser" dark color="primary" @click="dialogOkCancel=true" title="Manage Linked Company Account" :loading="loading_link">
                        <v-icon dark>input</v-icon>&nbsp;Manage Account&nbsp;&nbsp;
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card v-if="!loading" class="elevation-1 mt-5">
                <v-toolbar class="transparent" flat height="45">
                    <b class="primary--text">LINKED COMPANY DETAILS</b>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap class="form-row"> 
                        <v-flex xs3>
                            Company Name : 
                        </v-flex>
                        <v-flex xs9>
                            <v-chip class="user-chip-container">
                                <v-avatar>
                                    <v-img :src="commonfn.getCompanyLogoUrlByAccount(linked_account.accountNumber, linked_account.logoFileName)"></v-img>
                                </v-avatar>
                                    <b>{{ linked_account.companyName }}</b>
                            </v-chip>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="form-row"> 
                        <v-flex xs3>
                            Employees : 
                        </v-flex>
                        <v-flex xs9>
                            <b>{{ linked_account.employeeCount }}</b>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="form-row"> 
                        <v-flex xs3>
                            Created On : 
                        </v-flex>
                        <v-flex xs9>
                            <b>{{ linked_account.createdOn | moment('MMM DD, YYYY') }}</b>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-card v-if="!loading" class="elevation-1 mt-5">
                <v-toolbar class="transparent" flat height="45">
                    <b class="primary--text">ADMIN USERS</b>
                    <v-spacer></v-spacer>
                    <v-btn v-if="hasAddRights" dark fab small color="primary" @click="showAddUser" title="Manage Linked Company Account">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="linked_account.admins"
                        :loading="loading"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                    >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template v-slot:items="props">
                            <tr>
                                <td>
                                     <v-chip class="user-chip-container">
                                        <v-avatar size="30">
                                             <v-img :src="awsS3Helper.getAvatarUrl(props.item.parentUserId)"></v-img>
                                        </v-avatar>
                                        {{ props.item.firstName }} {{ props.item.lastName }}
                                    </v-chip>
                                   
                                </td>
                                <td>Admin</td>
                                <td>
                                    <v-btn v-if="hasDeleteRights" icon small title="Remove User" @click="removeUser(props.item)">
                                        <v-icon small>delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteSelectedUser"></delete>
        </v-dialog>
        <v-dialog v-model="dialogAddLinkAccountUser" persistent width="600">
            <add-link-account-user ref="addLinkedAcccountUser" :dialogAddLinkAccountUser.sync="dialogAddLinkAccountUser" @send="getLinkedAccount(false)"></add-link-account-user>
        </v-dialog>
        <v-dialog v-model="dialogOkCancel" persistent width="600">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="manageLinkAccount(false)"></ok-cancel>
        </v-dialog>
    </v-layout>
</template>

<script>

import commonfn from '@/common/functions'   //for refactor
import awsS3Helper from '@/helpers/aws-s3'
import companyApi from '@/api/company'
import auth from '@/auth/auth'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, getSearchKeyword, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import { hasAddRights, hasEditRights, hasDeleteRights } from '@/helpers/access-permissions'

export default {
    name: 'LinkedAccounts',
    metaInfo: {
        title: 'Company Linked Accounts',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Linked Accounts' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-link-account-user': ()=> import("@/components/Company/AddLinkedAccountUser"),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
        'delete': ()=> import("@/components/BasicPopups/Delete"),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)
        
        return {
            rowsPerPageItems,
            commonfn,
            awsS3Helper,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_link: false,
            dialogAddLinkAccountUser: false,
            dialogDelete: false,
            dialogOkCancel: false,
            headers: [
                {text:'Employee', align:'left', value:'avatar', width:'10%', sortable:false},
                {text:'Role', align:'left', value:'role', width:'10%', sortable:false},
                {text:'Action', align:'left', value:'role', width:'1%', sortable:false},
            ],
            linked_account: null,
            deleteUserData: null
        }
    },
    methods: {
        showDelete() {
            this.$refs.refDeleteComponent.setMessage(`Delete ${this.deleteUserData.firstName} ${this.deleteUserData.lastName} as Admin User?`)
            this.dialogDelete = true
        },
        async manageLinkAccount() {
            try {
                this.loading_link = true
                this.dialogOkCancel = true
                const linkUserId = this.linked_account.admins.filter(x => x.parentUserId == this.loggedInUserId)[0].linkUserId
                await auth.switchAccount(linkUserId)
                if (auth.loggedIn()) {
                    this.dialogOkCancel = false
                    this.loading_link = false
                    this.$router.push("/")
                    this.$root.$emit('switchAccount', null)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        removeUser(data) {
            if (data) {
                this.deleteUserData = data
                this.showDelete()
            }
        },
        async deleteSelectedUser() {
            try {
                this.loading_delete = true
                const response = await companyApi.deleteLinkedAccountUser(this.deleteUserData)
                if (response && response.status == 200) {
                    this.dialogDelete = false
                    this.getLinkedAccount(false)
                }
                this.loading_delete = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showAddUser() {
            this.$refs.addLinkedAcccountUser.setData(this.linked_account.admins)
            this.dialogAddLinkAccountUser = true
        },
        async getLinkedAccount(show_loading) {
            try {
                this.loading = show_loading
                const response = await companyApi.getLinkedAccount(this.selectedLinkedCompanyId)
                if (response && response.status == 200) {
                    this.linked_account = response.data.account
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        this.getLinkedAccount(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Linked Company Account'
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        selectedLinkedCompanyId() {
            return this.$route.params.companyId
        },
        companyLogoPath() {
            return process.env.VUE_APP_COMPANY_LOGO_URL
        },
        loggedInUserId() {
            return this.$store.state.userId
        },
        isLinkedAccountAdminUser() {
            if (this.linked_account && this.linked_account.admins.length) {
                return this.linked_account.admins.some(x => x.parentUserId == this.loggedInUserId)
            }
        },
        dialogOkCancelMsg() {
            if (this.linked_account) {
                return `You are about to log in to <b>${this.linked_account.companyName}</b> company account.<br>Do you want to proceed?`
            }
        },
    }
}
</script>
<style scoped>
.search-bar {
    width:50%;
    margin-bottom:10px;
}
.form-row {
    padding:0px 20px 0px 20px;
}
.form-row-mobile {
    padding:20px;
}
</style>